import { useState } from "react";
import { T } from "react-translator-component";
import {
  TextField,
  Button,
} from "@mui/material";

interface Props {
  comment: string;
  onSubmit: (text: string) => void;
  onClose: () => void;
  isEdit: boolean;
}

export default function CommentForm(
  {
    comment,
    onSubmit,
    onClose,
    isEdit,
  }: Props
) {
  const [text, setText] = useState<string>(comment);

  const handleSubmit = () => {
    if (!text) return
    onSubmit(text)
  }

  return (
    <>
      <TextField
        value={text}
        fullWidth
        placeholder={`${T("comment_placeholder")}`}
        onChange={(e) => setText(e.target.value)}
      />

      <div style={styles.btnContainer} >
        <Button
          onClick={() => handleSubmit()}
          disabled={text === ""}
          style={styles.submit}
        >
          {isEdit ? T("save") : T("send")}
        </Button>
        <Button onClick={() => onClose()}>
          {T("cancel")}
        </Button>
      </div>
    </>
  );
};

const styles = {
  btnContainer: {
    display: "flex",
    justifyContent: "flex-end",
    marginTop: 8,
  },

  submit: {
    marginRight: 8,
  }
}